import { Select } from 'antd';
import { useState, useCallback, useEffect, useMemo } from 'react';
import { API } from '../api';
import { notifyError } from '../store/utils';

interface StreetSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  street?: any;
  districtNo?: any;
  onChange?: (value: string) => void;
}

const StreetSelect: React.FC<StreetSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  street,
  districtNo,
  onChange,
}) => {
  const [state, updateState] = useState<any[]>([]);

  const onSearch = useCallback(
    async (query: string) => {
      try {
        const { result } = await API.get({ apiVersion: 'api' })(`/address/street/${districtNo}`);
        updateState(result?.data || []);
      } catch (error: any) {
        notifyError(error.message);
      }
    },
    [districtNo]
  );

  const loadFirst = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/address/streets/${districtNo}?page=1&size=10`
      );
      const list = result?.data || [];
      const check = list.filter((it: any) => it.no === street?.no);
      if (street && check.length) {
        updateState([...list, street]);
      } else {
        updateState(list);
      }
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [street, districtNo]);

  useEffect(() => {
    if (districtNo) {
      loadFirst();
    }
  }, [districtNo]);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.name,
        value: item.no,
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Баг хороо сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      //onSearch={(query: string) => onSearch(query)}
      optionFilterProp="label"
      onChange={onChange}
      options={options}
      value={value}
      disabled={!districtNo || disabled}
      //filterOption={false}
    />
  );
};

export default StreetSelect;
